const courseClassify = {
  state: {
    storeCourseLists: [],
    storeCourseSeconds: []
  },

  mutations: {
    SET_STORECOURSELISTS: (state, lists) => {
      state.storeCourseLists = lists
    },
    SET_STORECOURSESECONDS: (state, lists) => {
      state.storeCourseSeconds = lists
    }
  }
}

export default courseClassify



// WEBPACK FOOTER //
// ./src/store/modules/courseClassify.js